import { GridValidRowModel } from '@mui/x-data-grid-pro';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { RiskCategoryIcon } from '~/components/RiskCategoryIcon/RiskCategoryIcon';

interface RiskCategoryCellProps<R extends GridValidRowModel = any> {
  value: string;
  row: R;
}

export const RiskCategoryCell = <R extends GridValidRowModel = any>({ value, row }: RiskCategoryCellProps<R>) => {
  return row.score && value ? <RiskCategoryIcon id={value} score={row.score} /> : <>{NULLISH_CELL_VALUE}</>;
};
